import { getInitialFilter, PriceFilter } from '../../../analysis/stores/price.store';

export const DASHBOARD_PRICE_FILTER_YEAR: PriceFilter = getInitialFilter();

export const DASHBOARD_PRICE_FILTER_WEEK: PriceFilter = {
  ...DASHBOARD_PRICE_FILTER_YEAR,
  granularity: 'WEEK',
};
